"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BaseStoreApi: {
    getByIds: {
      maxIdsLimit: 100
    },
    search: {
      maxQParameterLength: 600
    },
    searchAllBatch: {
      maxQParameterLength: 600,
      maxResults: 1000,
      maxPages: 15
    }
  }
};